"use client";

import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Moon, Sun } from "lucide-react";

export default function AppearanceSettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold">Darstellung</h2>
        <p className="text-sm text-gray-500">
          Passe an, wie Workinger auf deinem Gerät aussieht
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Design</Label>
          <RadioGroup defaultValue="light" className="grid grid-cols-3 gap-4">
            <div>
              <RadioGroupItem
                value="light"
                id="light"
                className="peer sr-only"
              />
              <Label
                htmlFor="light"
                className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
              >
                <Sun className="mb-2 h-6 w-6" />
                Hell
              </Label>
            </div>
            <div>
              <RadioGroupItem value="dark" id="dark" className="peer sr-only" />
              <Label
                htmlFor="dark"
                className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
              >
                <Moon className="mb-2 h-6 w-6" />
                Dunkel
              </Label>
            </div>
            <div>
              <RadioGroupItem
                value="system"
                id="system"
                className="peer sr-only"
              />
              <Label
                htmlFor="system"
                className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-transparent p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mb-2 h-6 w-6"
                >
                  <rect width="14" height="6" x="5" y="14" rx="3" />
                  <rect width="10" height="6" x="9" y="4" rx="3" />
                  <path d="M2 20h.01" />
                  <path d="M7 20v-4" />
                  <path d="M20 10h.01" />
                  <path d="M15 10V6" />
                  <path d="M17 22h4" />
                  <path d="M17 2h4" />
                  <path d="M12 22h4" />
                  <path d="M12 2h4" />
                  <path d="M7 22h4" />
                  <path d="M7 2h4" />
                  <path d="M2 4h.01" />
                  <path d="M2 10h.01" />
                  <path d="M2 14h.01" />
                </svg>
                System
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
}
